import { useMutation } from "react-query";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function useAlterarEtiquetaConta() {
  return useMutation(
    (data: { id: string; etiquetaId: string }) => {
      return http.post(`/v1/conta/${data.id}/alterar-etiqueta`, data);
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useAlterarEtiquetaConta;
